module.exports = __webpack_public_path__ + "static/img/interBanner.edf2bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interBanner.png
// module id = pB5I
// module chunks = 1